<template>
	<div v-if="isMounted || !loading">
		<!-- EXISTEN MAS DE 1 CREDITO -->
		<vs-tabs v-if="allMasterTables.length > 1" v-model="activeTab" alignment="fixed" color="dark"
			class="tab-action-btn-fill-container">
			<vs-tab :disabled="activeProjects.length == 0" :label="'Vigentes (' + activeProjects.length + ')'">
				<vs-tabs alignment="center" class="tab-action-btn-fill-container">
					<vs-tab v-for="(project, i) in activeProjects" :key="i"
						:label="project.project_id + '-' + truncate(project.alias, 10)">
						<div class="tab-text">
							<div class="row">
								<div class="col-md-12">
									<div class="row">
										<div class="col-xs-12 col-sm-12">
											<h4 style="margin-bottom: 0px; margin-top: 15px;">
												<div class="flex justify-between flex-wrap small-flex">
													<div>
														<strong>{{project.project_id}} - {{project.alias}}</strong>
														<label class="ml-5 pill-danger" v-if="project.restructured_loan">Crédito Reestructurado</label>
													</div>
													<span><strong>Saldo insoluto: </strong>
														{{ costFormat(project.debit_balance) }} </span>
												</div>
											</h4>
										</div>
									</div>
									<br>
									<div class="table-responsive">
										<table class="table table-hover">
											<thead class="thead-dark">
												<tr>
													<th>Periodo</th>
													<th>Fecha de pago</th>
													<th>Pago</th>
													<th>Pago efectivo</th>
													<th>Saldo inicial</th>
													<th>Amortización</th>
													<th>Abono Capital</th>
													<th>Intereses</th>
													<th>IVA</th>
													<th>Comisión</th>
													<th>IVA Comisión</th>
													<th>Saldo final</th>
													<th></th>
													<th>Fecha pagada</th>
													<th>Meses atraso</th>
												</tr>
											</thead>
											<tbody>
												<tr :class="payment.negotiation_type && isNegotiationValid(payment.negotiation_type) ? 'bg-grey-light':''" v-for="(payment, m) in project.monthlyPayments" :key="m">
													<td>{{ payment.number }}</td>
													<td v-if="payment.negotiation_type && isNegotiationValid(payment.negotiation_type)">
														{{payment.payment_date | human_date}}<br>
														<span class="bold" >({{ negotiationTypeStr(payment.negotiation_type) }})</span>
													</td>
													<td v-else>{{ payment.payment_date | human_date }}</td>
													<td class="table-number">${{ formatPrice(payment.payment) }}</td>
													<td class="table-number bold" style="color:red">
														${{ formatPrice(payment.cash_payment) }}</td>
													<td class="table-number">${{ formatPrice(payment.initial_debt) }}</td>
													<td class="table-number">${{ formatPrice(payment.amortization) }}</td>
													<td class="table-number">${{ formatPrice(payment.capital_payment) }}
													</td>
													<td class="table-number">${{ formatPrice(payment.interest) }}</td>
													<td class="table-number">${{ formatPrice(payment.tax) }}</td>
													<td class="table-number">${{ formatPrice(payment.client_comission) }}
													</td>
													<td class="table-number">
														${{ formatPrice(payment.client_commission_tax) }}</td>
													<td class="table-number">${{ formatPrice(payment.final_debt) }}</td>
													<td v-if="payment.paid == 1" style="text-align:center;"><em
															class="material-icons" style="color:green">check_circle</em>
													</td>
													<td v-else-if="payment.with_due" style="text-align:center;"><em
															class="material-icons">attach_money</em></td>
													<td v-else style="text-align:center;">
														<em v-if="user.user_id == 1864 || user.user_id == 11838 && !loading"
															class="material-icons" style="cursor:pointer;"
															@click="due(payment, project)">add_circle</em>
													</td>
													<td v-if="payment.paid_date">
														{{ payment.paid_date | human_date }}
													</td>
													<td v-else>--</td>
													<td>{{ payment.months_late }}</td>
												</tr>
												<tr class="table-active">
													<td></td>
													<td class="table-number bold">Total</td>
													<td class="table-number bold">
														${{ formatPrice(project.totalMonthlyPayments.payment) }}</td>
													<td class="table-number bold"></td>
													<td class="table-number bold"></td>
													<td class="table-number bold">
														${{ formatPrice(project.totalMonthlyPayments.amortization) }}</td>
													<td class="table-number bold">
														${{ formatPrice(project.totalMonthlyPayments.capital_payment) }}
													</td>
													<td class="table-number bold">
														${{ formatPrice(project.totalMonthlyPayments.interest) }}</td>
													<td class="table-number bold">
														${{ formatPrice(project.totalMonthlyPayments.tax) }}</td>
													<td class="table-number bold">
														${{ formatPrice(project.totalMonthlyPayments.client_comission) }}
													</td>
													<td class="table-number bold">
														${{ formatPrice(project.totalMonthlyPayments.client_comission_tax) }}
													</td>
													<td class="table-number bold"></td>
													<td></td>
													<td></td>
													<td></td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
					</vs-tab>
				</vs-tabs>
			</vs-tab>
			<vs-tab :disabled="settleProjects.length == 0" :label="'Liquidados (' + settleProjects.length + ')'">
				<vs-tabs alignment="center" class="tab-action-btn-fill-container">
					<vs-tab v-for="(project, i) in settleProjects" :key="i"
						:label="project.project_id + '-' + truncate(project.alias, 10)">
						<div class="tab-text">
							<div class="row">
								<div class="col-md-12">
									<div class="row">
										<div class="col-xs-12 col-sm-12">
											<h4 style="margin-bottom: 0px; margin-top: 15px;">
												<div class="flex justify-between flex-wrap small-flex">
													<div>
														<strong>{{project.project_id}} - {{project.alias}}</strong>
														<label class="ml-5 pill-danger" v-if="project.restructured_loan">Crédito Reestructurado</label>
													</div>
													<span><strong>Saldo insoluto: </strong>
														{{ costFormat(project.debit_balance) }} </span>
												</div>
											</h4>
										</div>
									</div>
									<br>
									<div class="table-responsive">
										<table class="table table-hover">
											<thead class="thead-dark">
												<tr>
													<th>Periodo</th>
													<th>Fecha de pago</th>
													<th>Pago</th>
													<th>Pago efectivo</th>
													<th>Saldo inicial</th>
													<th>Amortización</th>
													<th>Abono Capital</th>
													<th>Intereses</th>
													<th>IVA</th>
													<th>Comisión</th>
													<th>IVA Comisión</th>
													<th>Saldo final</th>
													<th>Fecha pagada</th>
													<th>Meses atraso</th>
												</tr>
											</thead>
											<tbody>
												<tr :class="payment.negotiation_type && isNegotiationValid(payment.negotiation_type) ? 'bg-grey-light':''"
													v-for="(payment, m) in project.monthlyPayments" :key="m">
													<td>{{ payment.number }}</td>
													<td v-if="payment.negotiation_type && isNegotiationValid(payment.negotiation_type)">
														{{payment.payment_date | human_date}}<br>
														<span class="bold" >({{ negotiationTypeStr(payment.negotiation_type) }})</span>
													</td>
													<td v-else>{{ payment.payment_date | human_date }}</td>
													<td class="table-number">${{ formatPrice(payment.payment) }}</td>
													<td class="table-number bold" style="color:red">
														${{ formatPrice(payment.cash_payment) }}</td>
													<td class="table-number">${{ formatPrice(payment.initial_debt) }}</td>
													<td class="table-number">${{ formatPrice(payment.amortization) }}</td>
													<td class="table-number">${{ formatPrice(payment.capital_payment) }}
													</td>
													<td class="table-number">${{ formatPrice(payment.interest) }}</td>
													<td class="table-number">${{ formatPrice(payment.tax) }}</td>
													<td class="table-number">${{ formatPrice(payment.client_comission) }}
													</td>
													<td class="table-number">
														${{ formatPrice(payment.client_commission_tax) }}</td>
													<td class="table-number">${{ formatPrice(payment.final_debt) }}</td>
													<td v-if="payment.paid_date">
														{{ payment.paid_date | human_date }}
													</td>
													<td v-else>--</td>
													<td>{{ payment.months_late }}</td>
												</tr>
												<tr class="table-active">
													<td></td>
													<td class="table-number bold">Total</td>
													<td class="table-number bold">
														${{ formatPrice(project.totalMonthlyPayments.payment) }}</td>
													<td class="table-number bold"></td>
													<td class="table-number bold"></td>
													<td class="table-number bold">
														${{ formatPrice(project.totalMonthlyPayments.amortization) }}</td>
													<td class="table-number bold">
														${{ formatPrice(project.totalMonthlyPayments.capital_payment) }}
													</td>
													<td class="table-number bold">
														${{ formatPrice(project.totalMonthlyPayments.interest) }}</td>
													<td class="table-number bold">
														${{ formatPrice(project.totalMonthlyPayments.tax) }}</td>
													<td class="table-number bold">
														${{ formatPrice(project.totalMonthlyPayments.client_comission) }}
													</td>
													<td class="table-number bold">
														${{ formatPrice(project.totalMonthlyPayments.client_comission_tax) }}
													</td>
													<td></td>
													<td></td>
													<td></td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
					</vs-tab>
				</vs-tabs>
			</vs-tab>
			<vs-tab :disabled="backupAmortizationsProjects.length == 0" :label="'Reestructuras (' + backupAmortizationsProjects.length + ')'">
				<vs-tabs alignment="center" class="tab-action-btn-fill-container">
					<vs-tab v-for="(project, i) in backupAmortizationsProjects" :key="i" :label="project.project_id + '-' + truncate(project.alias, 10)">
						<div class="tab-text">
							<div class="row">
								<div class="col-md-12">
									<div class="row">
										<div class="col-xs-12 col-sm-12">
											<h4 style="margin-bottom: 0px; margin-top: 15px;">
												<label class="pill-dark">Versión previa a la reestructura</label>
											</h4>
										</div>
									</div>
									<br>
									<div class="table-responsive">
										<table class="table table-hover">
											<thead class="thead-inactive">
												<tr>
													<th>Periodo</th>
													<th>Fecha de pago</th>
													<th>Pago</th>
													<th>Pago efectivo</th>
													<th>Saldo inicial</th>
													<th>Amortización</th>
													<th>Abono Capital</th>
													<th>Intereses</th>
													<th>IVA</th>
													<th>Comisión</th>
													<th>IVA Comisión</th>
													<th>Saldo final</th>
													<th>Fecha pagada</th>
												</tr>
											</thead>
											<tbody>
												<tr :class="payment.negotiation_type && isNegotiationValid(payment.negotiation_type) ? 'bg-grey-light':''"
													v-for="(payment, m) in project.monthlyPaymentsBackup" :key="m">
													<td>{{ payment.number }}</td>
													<td v-if="payment.negotiation_type && isNegotiationValid(payment.negotiation_type)">
														{{payment.payment_date | human_date}}<br>
														<span class="bold" >({{ negotiationTypeStr(payment.negotiation_type) }})</span>
													</td>
													<td v-else>{{ payment.payment_date | human_date }}</td>
													<td class="table-number">${{ formatPrice(payment.payment) }}</td>
													<td class="table-number bold" style="color:red">
														${{ formatPrice(payment.cash_payment) }}</td>
													<td class="table-number">${{ formatPrice(payment.initial_debt) }}</td>
													<td class="table-number">${{ formatPrice(payment.amortization) }}</td>
													<td class="table-number">${{ formatPrice(payment.capital_payment) }}
													</td>
													<td class="table-number">${{ formatPrice(payment.interest) }}</td>
													<td class="table-number">${{ formatPrice(payment.tax) }}</td>
													<td class="table-number">${{ formatPrice(payment.client_comission) }}
													</td>
													<td class="table-number">
														${{ formatPrice(payment.client_commission_tax) }}</td>
													<td class="table-number">${{ formatPrice(payment.final_debt) }}</td>
													<td v-if="payment.paid_date">
														{{ payment.paid_date | human_date }}
													</td>
													<td v-else>--</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
					</vs-tab>
				</vs-tabs>
			</vs-tab>
		</vs-tabs>
		<!-- SOLO HAY 1 CREDITO -->
		<vs-tabs v-else v-model="activeTab" color="dark" alignment="center" class="tab-action-btn-fill-container">
			<vs-tab v-for="(project, i) in allMasterTables" :key="i" :label="project.project_id + '-' + project.alias">
				<div class="tab-text">
					<div class="row">
						<div class="col-md-12">
							<div class="row">
								<div class="col-xs-12 col-sm-12">
									<h4 style="margin-bottom: 0px; margin-top: 15px;">
										<div class="flex justify-between flex-wrap small-flex">
											<div>
												<strong>{{project.project_id}} - {{project.alias}}</strong>
												<label class="ml-5 pill-danger" v-if="project.restructured_loan">Crédito Reestructurado</label>
											</div>
											<span><strong>Saldo insoluto: </strong>
												{{ costFormat(project.debit_balance) }} </span>
										</div>
									</h4>
								</div>
							</div>
							<br>
							<div class="table-responsive">
								<table class="table table-hover">
									<thead class="thead-dark">
										<tr>
											<th>Periodo</th>
											<th>Fecha de pago</th>
											<th>Pago</th>
											<th>Pago efectivo</th>
											<th>Saldo inicial</th>
											<th>Amortización</th>
											<th>Abono Capital</th>
											<th>Intereses</th>
											<th>IVA</th>
											<th>Comisión</th>
											<th>IVA Comisión</th>
											<th>Saldo final</th>
											<th></th>
											<th>Fecha pagada</th>
											<th>Meses atraso</th>
										</tr>
									</thead>
									<tbody>
										<tr :class="payment.negotiation_type && isNegotiationValid(payment.negotiation_type) ? 'bg-grey-light':''"
											v-for="(payment, m) in project.monthlyPayments" :key="m">
											<td>{{ payment.number }}</td>
											<td v-if="payment.negotiation_type && isNegotiationValid(payment.negotiation_type)">
												{{payment.payment_date | human_date}}<br>
												<span class="bold" >({{ negotiationTypeStr(payment.negotiation_type) }})</span>
											</td>
											<td v-else>{{ payment.payment_date | human_date }}</td>
											<td class="table-number">${{ formatPrice(payment.payment) }}</td>
											<td class="table-number bold" style="color:red">
												${{ formatPrice(payment.cash_payment) }}</td>
											<td class="table-number">${{ formatPrice(payment.initial_debt) }}</td>
											<td class="table-number">${{ formatPrice(payment.amortization) }}</td>
											<td class="table-number">${{ formatPrice(payment.capital_payment) }}
											</td>
											<td class="table-number">${{ formatPrice(payment.interest) }}</td>
											<td class="table-number">${{ formatPrice(payment.tax) }}</td>
											<td class="table-number">${{ formatPrice(payment.client_comission) }}
											</td>
											<td class="table-number">
												${{ formatPrice(payment.client_commission_tax) }}</td>
											<td class="table-number">${{ formatPrice(payment.final_debt) }}</td>
											<td v-if="payment.paid == 1" style="text-align:center;"><em class="material-icons"
													style="color:green">check_circle</em>
											</td>
											<td v-else-if="payment.with_due" style="text-align:center;"><em
													class="material-icons">attach_money</em></td>
											<td v-else style="text-align:center;">
												<em v-if="user.user_id == 1864 || user.user_id == 11838 && !loading"
													class="material-icons" style="cursor:pointer;"
													@click="due(payment, project)">add_circle</em>
											</td>
											<td v-if="payment.paid_date">
												{{ payment.paid_date | human_date }}
											</td>
											<td v-else>--</td>
											<td>{{ payment.months_late }}</td>
										</tr>
										<tr class="table-active">
											<td></td>
											<td class="table-number bold">Total</td>
											<td class="table-number bold">
												${{ formatPrice(project.totalMonthlyPayments.payment) }}</td>
											<td class="table-number bold"></td>
											<td class="table-number bold"></td>
											<td class="table-number bold">
												${{ formatPrice(project.totalMonthlyPayments.amortization) }}</td>
											<td class="table-number bold">
												${{ formatPrice(project.totalMonthlyPayments.capital_payment) }}
											</td>
											<td class="table-number bold">
												${{ formatPrice(project.totalMonthlyPayments.interest) }}</td>
											<td class="table-number bold">
												${{ formatPrice(project.totalMonthlyPayments.tax) }}</td>
											<td class="table-number bold">
												${{ formatPrice(project.totalMonthlyPayments.client_comission) }}
											</td>
											<td class="table-number bold">
												${{ formatPrice(project.totalMonthlyPayments.client_comission_tax) }}
											</td>
											<td class="table-number bold"></td>
											<td></td>
											<td></td>
											<td></td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</vs-tab>
			<vs-tab v-for="(project, i) in backupAmortizationsProjects" :key="i" :label="project.project_id +' (Reestructura)'">
				<div class="tab-text">
					<div class="row">
						<div class="col-md-12">
							<div class="row">
								<div class="col-xs-12 col-sm-12">
									<h4 style="margin-bottom: 0px; margin-top: 15px;">
										<label class="pill-dark">Versión previa a la reestructura</label>
									</h4>
								</div>
							</div>
							<br>
							<div class="table-responsive">
								<table class="table table-hover">
									<thead class="thead-inactive">
										<tr>
											<th>Periodo</th>
											<th>Fecha de pago</th>
											<th>Pago</th>
											<th>Pago efectivo</th>
											<th>Saldo inicial</th>
											<th>Amortización</th>
											<th>Abono Capital</th>
											<th>Intereses</th>
											<th>IVA</th>
											<th>Comisión</th>
											<th>IVA Comisión</th>
											<th>Saldo final</th>
											<th>Fecha pagada</th>
										</tr>
									</thead>
									<tbody>
										<tr :class="payment.negotiation_type && isNegotiationValid(payment.negotiation_type) ? 'bg-grey-light':''"
											v-for="(payment, m) in project.monthlyPaymentsBackup" :key="m">
											<td>{{ payment.number }}</td>
											<td v-if="payment.negotiation_type && isNegotiationValid(payment.negotiation_type)">
												{{payment.payment_date | human_date}}<br>
												<span class="bold" >({{ negotiationTypeStr(payment.negotiation_type) }})</span>
											</td>
											<td v-else>{{ payment.payment_date | human_date }}</td>
											<td class="table-number">${{ formatPrice(payment.payment) }}</td>
											<td class="table-number bold" style="color:red">
												${{ formatPrice(payment.cash_payment) }}</td>
											<td class="table-number">${{ formatPrice(payment.initial_debt) }}</td>
											<td class="table-number">${{ formatPrice(payment.amortization) }}</td>
											<td class="table-number">${{ formatPrice(payment.capital_payment) }}
											</td>
											<td class="table-number">${{ formatPrice(payment.interest) }}</td>
											<td class="table-number">${{ formatPrice(payment.tax) }}</td>
											<td class="table-number">${{ formatPrice(payment.client_comission) }}
											</td>
											<td class="table-number">
												${{ formatPrice(payment.client_commission_tax) }}</td>
											<td class="table-number">${{ formatPrice(payment.final_debt) }}</td>
											<td v-if="payment.paid_date">
												{{ payment.paid_date | human_date }}
											</td>
											<td v-else>--</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</vs-tab>
		</vs-tabs>
	</div>
</template>

<script>
import { formatPrice, formatMoney } from '../../../../components/admin/filters.js';
import formatHelper from '@mixins/formatHelper';
import * as moment from 'moment'
export default {
	name: "MasterAmortizationProjects",
	props: ['project_id'],
	mixins: [formatHelper],
	async mounted() {
		await this.getMaster();
		this.isMounted = true;
	},
	data() {
		return {
			negotiationsToShowOnTable: [
				"solo_intereses",
				"meses_de_gracia",
				"quita",
				"puesta_al_corriente"
			],
			allMasterTables: [],
			activeProjects: [],
			backupAmortizationsProjects: [],
			settleProjects: [],
			loading: false,
			isMounted: false,
			activeTab: 0,
			total: {}
		}
	},
	filters: {
		human_date(date) {
			return moment(date).lang("es").format("D MMM YYYY");
		}
	},
	methods: {
		formatPrice,
		async getMaster() {
			this.loading = true;
			this.showLoading(true);
			await axios.get('/api/cobranza/proyectos/' + this.project_id + '/clientProjectsMaster').then(response => {
				this.allMasterTables = response.data.allMasterTables;
				this.allMasterTables.forEach((opt) => {
					if (opt.loan_status == "Liquidado") {
						this.settleProjects.push(opt);
					} else {
						this.activeProjects.push(opt);
					}
					// si cuenta con backup por restructuras se agrega
					if(opt.monthlyPaymentsBackup.length > 0){
						this.backupAmortizationsProjects.push(opt)
					}
				});

				if (this.allMasterTables.length > 1) {
					if (this.activeProjects.length > 0) {
						this.activeTab = 0;
					} else if(this.settleProjects.length > 0) {
						this.activeTab = 1;
					} else if(this.backupAmortizationsProjects.length > 0) {
						this.activeTab = 2;
					}
				}
			}).catch();
			this.loading = false;
			this.showLoading(false);
		},
		async due(m, project) {
			var fa = prompt(`Generar adeudo al proyecto ${project.alias} de $ ${this.formatPrice(m.payment, 2)} correspondiente al mes ${m.number} con fecha de pago ${m.payment_date}.\nConfirma con tu segundo factor de autenticación:`, '');
			if (fa !== null && fa !== '') {
				this.loading = true;
				this.showLoading(true);
				await axios.post('/api/cobranza/master/adeudoProject', {
					project_id: project.project_id,
					payment_date: m.payment_date,
					code: fa
				}).then(response => {
					this.showLoading(false);
					this.$emit('updated', 1)
					//this.getMaster()
				}).catch(error => {
					this.showLoading(false);
					if (error.response.data.message != undefined) {
						this.errorNotif("Aviso", error.response.data.message, 4000);
					} else {
						this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
					}
				});
				this.loading = false;
			}
		},
		isNegotiationValid(negotiationType){
			return this.negotiationsToShowOnTable.includes(negotiationType);
		},
		negotiationTypeStr(type) {
			var negotiationTypeStr = "No definido";
			switch (type) {
				case "solo_intereses":
					negotiationTypeStr = "Solo intereses";
					break;
				case "meses_de_gracia":
					negotiationTypeStr = "Mes de gracia";
					break;
				case "reestructura":
					negotiationTypeStr = "Reestructura";
					break;
				case "quita":
					negotiationTypeStr = "Quita aplicada";
					break;
				case "puesta_al_corriente":
					negotiationTypeStr = "Descuento";
					break;
				default:
					break;
			}
			return negotiationTypeStr;
		},
		truncate(text, length) {
			return text.length > length
				? text.slice(0, length) + '...'
				: text
		},
	}
}
</script>

<style scoped>
td,
th {
	text-align: center;
	vertical-align: middle;
}

.table {
    margin-bottom: 0;
}

.table .thead-inactive th {
    color: #fafafa;
    background-color: #808080;
    border-color: #808080;
}

.table-responsive {
	border-radius: 10px;
}

</style>
